import { InjectionToken } from '@angular/core';
import { AuthHeaders } from '../interfaces/auth-headers.interface';

export const AUTH_HEADERS_CONFIG = new InjectionToken<AuthHeaders>(
  'Auth Headers Config Per Deployment Environment'
);
